import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
import { Link } from 'react-router-dom'
const OurManager = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Our Managers" midBreadcrumb="Office Bearers" mainBreadcrumb="Our Managers" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div class="row uniform">
                        <div class="col-12">

                            <h2 class="mainhead" >Our Managers</h2>
                            <h3 class="subhead text-center" >A committee is a group that
                                keeps minutes and loses hours</h3>
                            <div class="auto-container">
                                <div class="row clearfix">


                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img
                                                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Manager-2025.jpg"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Father Ranjit Soreng sfx</a></h3>
                                                <div class="designation">2025 to Present</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img
                                                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/manager-2023.jpg"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Fr. Anthony Manuel Fernandes, Sfx</a></h3>
                                                <div class="designation">2023 to Present</div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/manager.png"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. Jose Stephen. Sfx</a></h3>
                                                <div class="designation">2019 to 2021</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/boy.png"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. Victor Rebello SFX</a></h3>
                                                <div class="designation">2018 to 2019</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/boy.png"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. Anthony Mario Fernandes SFX</a></h3>
                                                <div class="designation">2014 to 2018</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/boy.png"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. Maria Michael SFX</a></h3>
                                                <div class="designation">2013 to 2014</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/boy.png"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. Peter Rodrigues SFX</a></h3>
                                                <div class="designation">2005 to 2013</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default OurManager